
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/dhi-videos",
      function () {
        return require("private-next-pages/archive/dhi-videos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/dhi-videos"])
      });
    }
  